import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { EntityBase } from './EntityBase';

export class InsuranceCompanySeed extends EntityBase {
    Name: string = '';
    LogoFileId: string;
    CompanyType: string;
    Address: InsuranceCompanyAddress;
    DepartmentInfoList: DepartmentInfo[] = [];
    BexioInfo: InsuranceCompanyBexioInfo = null;
    DisplayOrder: number;
    CompanyDescription: string;
    ServiceProducts: InsuranceCompanyServiceProduct[];
    IsActive: boolean = false;
    SlaDaysOfDelay: number;
    BexioContactId: number;
    IsLiabilityEvaluationMinimumThresholdPercentageEnabled: boolean;
    LiabilityEvaluationMinimumThresholdPercentage: number;
}

export class DepartmentInfo {
    LogoFileId: string;
    DepartmentId: string;
    DepartmentName: string;
    TranslatedDepartmentName: string;
    Email: string;
    InvoiceType: string;
    ReportDispatchTypeOption: string;
    ReportDispatchType: string;
    EmailType?: string;
    ConfigId?: string;
    EmailAuthorizationStatus: string;
    ToRecipent: string[];
    UIConfiguration: DepartmentBadgeUIConfig;
    SLAEmailDispatchType: string;
    SLAEmailCustomReceivers: string[];
    InvoiceReceiver: string;
    InvoiceReceiverEmail: string;
    Priority: boolean;
    Language: string;
    CcRecipient?: string[];
    IsActive: boolean = true;
    InputChannel: string;
    IsAutomaticClearingEnable: boolean = false;
    IsAnonymizedReportEnable?: boolean = false;
    constructor(deptInfo?) {
        this.LogoFileId = (deptInfo && deptInfo.LogoFileId) || '';
        this.DepartmentId = (deptInfo && deptInfo.DepartmentId) || '';
        this.DepartmentName = (deptInfo && deptInfo.DepartmentName) || '';
        this.TranslatedDepartmentName = (deptInfo && deptInfo.TranslatedDepartmentName) || '';
        this.Email = (deptInfo && deptInfo.Email) || '';
        this.InvoiceType = (deptInfo && deptInfo.InvoiceType) || '';
        if (deptInfo && deptInfo.ReportDispatchType) {
            if (
                [SCConfig.returnToOrderSenderType, SCConfig.ReportEmailDispatchType.SendToInsuranceOffice].includes(
                    deptInfo.ReportDispatchType
                )
            ) {
                this.ReportDispatchTypeOption = deptInfo.ReportDispatchType;
            } else {
                this.ReportDispatchTypeOption = SCConfig.ReportEmailDispatchType.SendToCustom;
            }
        } else {
            this.ReportDispatchTypeOption = SCConfig.returnToOrderSenderType;
        }
        this.ReportDispatchType = (deptInfo && deptInfo.ReportDispatchType) || '';
        this.SLAEmailDispatchType =
            (deptInfo && deptInfo.SLAEmailDispatchType) || SCConfig.ReportEmailDispatchType.SendToEmailSender;
        this.SLAEmailCustomReceivers = (deptInfo && deptInfo.SLAEmailCustomReceivers) || [];
        this.InvoiceReceiver = deptInfo && deptInfo.InvoiceReceiver;
        this.InvoiceReceiverEmail = deptInfo && deptInfo.InvoiceReceiverEmail;
        this.ConfigId = (deptInfo && deptInfo.ConfigId) || '';
        this.EmailType = (deptInfo && deptInfo.EmailType) || '';
        this.EmailAuthorizationStatus = (deptInfo && deptInfo.EmailAuthorizationStatus) || '';
        this.UIConfiguration = (deptInfo && deptInfo.UIConfiguration) || null;
        this.Priority = (deptInfo && deptInfo.Priority) || false;
        this.Language = (deptInfo && deptInfo.Language) || null;
        this.CcRecipient = (deptInfo && deptInfo.CcRecipient) || [];
        this.IsActive = (deptInfo && deptInfo.IsActive) || true;
        this.InputChannel = deptInfo?.InputChannel ?? null;
        this.IsAutomaticClearingEnable = deptInfo?.IsAutomaticClearingEnable || false;
        this.IsAnonymizedReportEnable = deptInfo?.IsAnonymizedReportEnable || false;
    }
}
export class InsuranceCompanyAddress {
    CompanyName: string;
    Country: string;
    CountryCode: string;
    Streat: string;
    PostCode: number;
    Area: string;
}

export class DepartmentBadgeUIConfig {
    BackgroundColor: string;
    FontColor: string;
    BorderColor: string;
}

export class InsuranceCompanyBexioInfo {
    BexioCurrentAmount: number;
    BexioNextAmount: number | null;
    BexioEffectiveDate: string | null;
    HangfireJobId: string | null;
    constructor() {
        this.BexioCurrentAmount = 99;
        this.BexioNextAmount = null;
        this.BexioEffectiveDate = null;
        this.HangfireJobId = null;
    }
}

export class InsuranceCompanyServiceProduct {
    ServiceProductId: string;
    IsActive: boolean;
    Threshold: number;
    ThresholdUpdateDate: Date;
}
